export default __webpack_public_path__ + "static/media/download_record_complete.be4f1bec.svg";